import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import STUtils from "../../assets/styles/utility.module.scss";
import { routes } from "../../router/Router";
import { postMemberLinkUserLineAccount } from "../../utils/api/postMemberLinkUserLineAccount";
import { getSubdomain } from "../../utils/getSubdomain";
import LoginBackground from "../organisms/LoginBackground";
import LoginForm from "../organisms/LoginForm";
import PWAInstallationModal from "../organisms/PWAInstallationModal";
import BaseHeadNoindex from "../templates/BaseHeadNoindex";

const Login: React.FC = () => {
  const subdomain = getSubdomain(window.location.hostname);
  const query = new URLSearchParams(useLocation().search);

  const history = useHistory();
  const linkToken = query.get("linkToken")
    ? String(query.get("linkToken"))
    : undefined;
  const auth = getAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (auth.currentUser) {
      if (linkToken !== undefined) {
        postMemberLinkUserLineAccount({
          linkToken,
        })
          .then((res) => {
            window.location.href = res.result!.values;
          })
          .catch(() => {
            history.push(routes.error.path);
          });
      } else {
        history.push(routes.top.path);
      }
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) return <></>;

  return (
    <BaseHeadNoindex
      title={routes.login.title}
      login={false}
      subdomain={subdomain}
      hasBackground={true}
    >
      <LoginBackground />
      <div className={`${STUtils.input_form} ${STUtils.container_large}`}>
        <LoginForm linkToken={linkToken} />
      </div>
      <PWAInstallationModal closePopup={() => {}} />
    </BaseHeadNoindex>
  );
};

export default Login;
